import React from 'react';
import classnames from 'classnames';
import { translate } from 'Shared/translate';
import { TINY, MEDIUM, SMALL } from 'Shared/breakpoints';
import { ProductHeaderRow as ProductHeaderRowTableLayout } from './TableLayout';
import * as styles from './base.scss';
export default class ProductHeaderRow extends React.Component {
    render() {
        switch (this.props.appearance) {
            case 'slim':
                return null; // TODO implement slim version, maybe APP here?
            case 'compact':
                return (this.props.currentBreakpoint > TINY && (React.createElement("div", { className: classnames(styles.head, !!this.props.isCart && styles.isCheckout, !!this.props.isCheckout &&
                        this.props.currentBreakpoint <= MEDIUM &&
                        this.props.currentBreakpoint > SMALL &&
                        styles.medium) },
                    React.createElement("div", { className: styles.col1 }, translate('/ProductListing/ArticleNumber')),
                    React.createElement("div", { className: styles.col2 }, translate('/ProductListing/DisplayName')),
                    this.props.isCart && !this.props.isCheckout && React.createElement("div", { className: styles.col3 }),
                    this.props.hasAmountNeeded && (React.createElement("div", { className: styles.col4 }, translate('/ProductListing/AmountNeeded'))),
                    this.props.isSupplierSalesman && (React.createElement("div", { className: styles.col5 }, translate('/ProductListing/IsProductSample'))),
                    React.createElement("div", { className: styles.col5 }, translate('/ProductListing/Area')),
                    React.createElement("div", { className: styles.col6 }, translate('/ProductListing/Price')),
                    React.createElement("div", { className: styles.col7 }, translate('/ProductListing/StockStatusCompact')),
                    React.createElement("div", { className: styles.col8 }, translate('/ProductListing/Quantity')),
                    this.props.isCart && !this.props.isSupplierSalesman && (React.createElement("div", { className: styles.col9 }, translate('/ProductListing/Sum'))),
                    (this.props.isCart || this.props.hasDelete) && React.createElement("div", { className: styles.col10 }))));
            case 'simple':
                return (this.props.currentBreakpoint > TINY && (React.createElement("div", { className: styles.head },
                    React.createElement("div", { className: styles.col1 }, translate('/ProductListing/ArticleNumber')),
                    React.createElement("div", { className: styles.col2 }, translate('/ProductListing/DisplayName')),
                    React.createElement("div", { className: styles.col4 }, translate('/ProductListing/UnitCompact')),
                    React.createElement("div", { className: styles.col5 }, translate('/ProductListing/Area')),
                    this.props.isSupplierSalesman && (React.createElement("div", { className: styles.col5 }, translate('/ProductListing/IsProductSample'))),
                    React.createElement("div", { className: styles.col6 }, translate('/ProductListing/Price')),
                    React.createElement("div", { className: styles.col7 }, translate('/ProductListing/StockStatusCompact')))));
            case 'compact-mobile':
                return React.createElement("h4", null, translate('/ProductListing/Products'));
            case 'subDelivery':
                return null;
            case 'tableversion':
                return React.createElement(ProductHeaderRowTableLayout, null);
            default:
                return null;
        }
    }
}
